import {FC, useMemo} from 'react';
//mui
import {Box, Button, SxProps, Theme} from '@mui/material';
//formik
import {FieldInputProps, FormikProps} from 'formik';
//constants
import {TEXT} from '@/utils/constants';
//styles
import {maskSwitchStyle} from './MaskSwitch.styles';

interface MaskSwitch {
	masks: string[] | number[];
	parentClassName?: SxProps<Theme>;
	value?: string | number;
	field?: FieldInputProps<string | number>;
	form?: FormikProps<any>;
	onChange?: (event: string | number) => void;
}

const MaskSwitch: FC<MaskSwitch> = ({field, value, form, parentClassName, masks, onChange}) => {
	const isMaskActive = useMemo(() => masks[0] === value || masks[0] === field?.value, [value, field?.value]);

	const changeHandler = (value: string | number) => {
		if (onChange) {
			onChange(value);
		} else if (form && field) {
			form.setFieldValue(field.name, value);
		}
	};

	return (
		<Box sx={{...maskSwitchStyle.wrapper, parentClassName}}>
			<Box sx={{...maskSwitchStyle.mask, ...(isMaskActive && maskSwitchStyle.activeMask)}} />

			{masks.map((mask) => (
				<Button
					disableRipple
					key={mask}
					variant={TEXT}
					sx={{
						...maskSwitchStyle.button,
						...((mask === value || mask === field?.value) && maskSwitchStyle.buttonActive),
					}}
					onClick={() => changeHandler(mask)}
				>
					{mask}
				</Button>
			))}
		</Box>
	);
};

export default MaskSwitch;
